import { cloneDeep, isEqual } from 'lodash'

import { Colors } from '@sigma-frontend-libs/commons'

import { proxy } from '@/utils'

import render from './render'

/**
 * Кнопка фильтра списка с меню.
 * Меню выводит в столбец заголовок, содержимое слота по умолчанию и кнопку сброса.
 * Значение - объект фильтра; кнопка управляет ключами, перечисленными в `defaultValue`.
 * Кнопка сброса возвращает эти ключи к значениям `defaultValue`, остальные ключи фильтра не меняются.
 */
export default {
  name: 'ButtonFilter',

  mixins: [ proxy({ type: 'object' }) ],

  computed: {
    /**
     * Признак совпадения ключей фильтра из `defaultValue` со значениями по умолчанию.
     *
     * @returns {boolean} `true`, если сбрасывать нечего.
     */
    isDefault() {
      return Object.keys(this.defaultValue).every(key => {
        return isEqual(this.proxy[key], this.defaultValue[key])
      })
    },

    /**
     * Цвет кнопки открытия меню.
     *
     * @returns {string|undefined} `Colors.primary`, если фильтр отличается от значения по умолчанию.
     */
    activatorColor() {
      if (!this.isDefault) {
        return Colors.primary
      }
    }
  },

  methods: {
    /**
     * Возвращает ключи фильтра из `defaultValue` к значениям по умолчанию.
     */
    reset() {
      this.proxy = {
        ...this.proxy,
        ...cloneDeep(this.defaultValue)
      }
    }
  },

  render
}
